<!-- 总屏中间区域的农业总产值与生产规模 -->
<style lang="stylus" scoped>
  .describe
    display flex
    justify-content space-between
    color #fff
    text-align center
    .left, .right
      width 50%
    .title
      width 143px
      height 42px
      line-height 42px
      margin 20px auto
      background:rgba(8,26,84,0);
      border: 1px solid rgba(0,96,255,1);
      box-shadow: inset 0px 0px 30px 0px rgba(0,96,255,0.5);
      font-size:18px;
      font-weight:bold;
    .detail
      display flex
      .item
        width 30%
        P
          margin-bottom 10px
        .name
          font-size 18px
          font-weight bold
        .num
          color #FFDD01
          font-size 18px
          font-weight bold
          span
            font-size 12px
            font-weight 400
            color #fff
        .percent
          font-size 16px
          font-weight 400
          color #EF850E
          &:after
            display inline-block
            content ''
            width 10px
            height 11px
            margin-left 5px
            background url('../../../../../static/img/dashboard/rate-icon.png')
        .percent1
          font-size 16px
          font-weight 400
          color #00fefb
          &:after
            display inline-block
            content ''
            width 10px
            height 11px
            margin-left 5px
            background url('../../../../../static/img/dashboard/down_icon.png')
</style>

<template>
    <div class="describe">
      <div class="left">
        <div class="title">农业总产值</div>
        <div class="detail">
          <div class="item">
            <p class="name">农业</p>
            <p class="num">34.24 <span>亿元</span></p>
            <p class="percent">5.60%</p>
          </div>
          <div class="item">
            <p class="name">牧业</p>
            <p class="num">6.0151 <span>亿元</span></p>
            <p class="percent1">-1.82%</p>
          </div>
          <div class="item">
            <p class="name">渔业</p>
            <p class="num">1.342 <span>亿元</span></p>
            <p class="percent1">-18.83%</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">生产规模</div>
        <div class="detail">
          <div class="item">
            <p class="name">种植业</p>
            <p class="num">79.2 <span>万亩</span></p>
            <p class="percent">6.80%</p>
          </div>
          <div class="item">
            <p class="name">畜牧业</p>
            <p class="num">30.703<span>万头</span></p>
            <p class="percent1">-1.12%</p>
          </div>
          <div class="item">
            <p class="name">渔业</p>
            <p class="num">15840 <span>吨</span></p>
            <p class="percent1">-16.58%</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  components: {
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?0f2a7711